module.exports = __webpack_public_path__ + "media/images/logo_small-575f2280ca81c6095a84923f71b8919b.jpeg";